export default __webpack_public_path__ + "static/media/brush.2e6e7595.png";